import React from 'react'
import Footer from './shared/footer.jsx'
import Navbar from './shared/navbar.jsx'
import Header from './shared/header'
import ReactGA from 'react-ga'
import { getHeapTracker, getSalesforceChatConfig } from '../components/api'
import IdleTimer from 'react-idle-timer';
declare var SalesForceChat; //This is not an error, browser and compiler can recognize the reserved word declare.

export default React.createClass({
  getInitialState: function () {
    return {
      curAddressIndex: this.checkForCookie(),
      billingHistory: '',
      timeout: 3600000   // react-idle-timer timeout value (millis)
    }
  },
  componentDidMount: function() {
    let loginData = this.props.route.loginData;
    getHeapTracker().then((data) => {
      if(data.data === true) {
        if (window.activateHeap !== undefined) window.activateHeap();
      }
    })
    getSalesforceChatConfig().then((data) => {
      var sfChat = new SalesForceChat(data.baseCoreURL, data.communityEndpointURL,
            data.baseLiveAgentContentURL, data.baseLiveAgentURL, data.eswLiveAgentDevName, data.orgId,
            data.eswConfigDevName, data.deploymentId, data.buttonId);
        sfChat.embedChat('storeFront', false, {loginName: loginData.customer.loginName,fullName: (loginData.customer.firstName ? loginData.customer.firstName : loginData.customer.name) + ' ' + (loginData.customer.lastName ? loginData.customer.lastName : '')});
    })
  },
  reportAddressChange: function (index) {
    this.setState({curAddressIndex: index})
    document.cookie="addressId=" + index + '; Path=/; Expires=Wed, 01 Jan 2020 00:00:00 GMT'

  },
  checkForCookie: function () {
    let cookieValue = this.readCookieAddressIndex();
    if (cookieValue !== '') {
        return cookieValue
    } else {
       document.cookie="addressId=" + 0 + '; Path=/; Expires=Wed, 01 Jan 2020 00:00:00 GMT'
       return 0
    }
  },
  optOut: function(){
    ReactGA.event({
      category: 'Opt-Out Consumer Beta Dashboard',
      action: 'click',
      label: 'Opt-Out Button'
    })
    document.cookie = 'optIntoBeta=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    window.location.href = '/customer/showCustomerDashboard'
  },
  readCookieAddressIndex: function () {
    let name =  "addressId=";
    let ca = document.cookie.split(';')
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
  },
  idleTimeoutAction: function () {
    // from navbar.logout():
    document.cookie = "addressId=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    document.cookie = "optOutOfBeta=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    // invoke logout route on server:
    window.location.replace(window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/logout?timeout=true");
  },
  render: function () {
    let loginData = (this.props.route && this.props.route.loginData) ? this.props.route.loginData : {}
    let verifiedAddressIndex = this.state.curAddressIndex
    if(loginData.customer.addresses.length < this.state.curAddressIndex) {
      verifiedAddressIndex = 0
      document.cookie="addressId=" + verifiedAddressIndex + '; Path=/; Expires=Wed, 01 Jan 2020 00:00:00 GMT'
    }
    let currentAddress = loginData.customer.addresses[verifiedAddressIndex]
    const childrenWithProps = React.Children.map(this.props.children,
       (child) => React.cloneElement(child, {
         loginData: loginData,
         curAddressIndex: verifiedAddressIndex,
         reportAddressChange: this.reportAddressChange,
         currentAddress: currentAddress,
         billingHistory: this.state.billingHistory,
         initialData: this.state.initialData
       })
      )

      if (this.props.router.getCurrentLocation().pathname.includes("/invoice")) {
          // Invoice has its own self contained style container for header and such.
          return (<div>{childrenWithProps}</div>)
      } else {
          return (
          <IdleTimer
                  ref="idleTimer"
                  element={document}
                  activeAction={this._onActive}
                  idleAction={this.idleTimeoutAction}
                  timeout={this.state.timeout}
                  format="MM-DD-YYYY HH:MM:ss.SSS">
            <div className='concrete-gray-background'>
                <div className='container-fluid'>
                  <div className='row'>
                    <Header optOut={() => this.optOut()}/>
                    <Navbar optOut={() => this.optOut()} routes={this.props.route} />
                      <div className='spacer' />
                  </div>
                </div>
                <div>{childrenWithProps}</div>
                <Footer />
              </div>
          </IdleTimer>
          )
      }
  }
})



// WEBPACK FOOTER //
// ./src/components/App.js